import React from 'react';
import { Star } from 'lucide-react';
const testimonials = [{
  initials: 'CG',
  quote: '"Organicé mis precios y políticas en una tarde"',
  author: 'Carla G. | Manicurista Independiente'
}, {
  initials: 'LR',
  quote: '"Mis clientas por fin respetan mis horarios"',
  author: 'Laura R. | Centro de Estética'
}, {
  initials: 'MT',
  quote: '"Nunca más improvisé un presupuesto"',
  author: 'Mica T. | Nail Artist'
}];
export function MiniTestimonials() {
  return <section className="py-10 bg-ocean-cream border-b border-gray-100" data-id="element-153">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-154">
        <div className="grid md:grid-cols-3 gap-6" data-id="element-155">
          {testimonials.map((t, i) => <div key={i} className="bg-white p-5 rounded-2xl shadow-sm border border-gray-100 flex flex-col items-center text-center" data-id="element-156">
              <div className="w-12 h-12 bg-ocean-teal-light text-ocean-teal-dark rounded-full flex items-center justify-center font-bold text-lg mb-3" data-id="element-157">
                {t.initials}
              </div>
              <div className="flex text-ocean-gold mb-3" data-id="element-158">
                {[...Array(5)].map((_, idx) => <Star key={idx} className="w-4 h-4 fill-current" data-id="element-159" />)}
              </div>
              <p className="text-gray-900 font-medium mb-2" data-id="element-160">{t.quote}</p>
              <p className="text-xs text-gray-500" data-id="element-161">— {t.author}</p>
            </div>)}
        </div>
      </div>
    </section>;
}